import request from '@/utils/request'

export function getBlEmailBlock(billEmailAddr) {
    return request({
        url: `/ococ/datacapture/auth/emailBlock`,
        method: 'get',
        headers: {
            billEmailAddr: window.btoa(billEmailAddr)
        }
    })
}

export function createAppFormEndding(registration) {
    return request({
        url: `/ococ/datacapture/openmarket/appFormEndding`,
        method: 'post',
        data: registration
    })
}

export function createRegistration(registration, entrRsvTruthInfo, lawcAgntEntrRsvTruthInfo, openMarketAgrInfo, step) {
    //console.log("function createRegistration openMarketAgrInfo:", openMarketAgrInfo);
    let assignedRegistration = {}
      let assignedEntrRsvTruthInfo = {}
      let assignedLawcAgntEntrRsvTruthInfo = {}
        Object.assign(assignedRegistration, registration)
        Object.assign(assignedEntrRsvTruthInfo, entrRsvTruthInfo)
        Object.assign(assignedLawcAgntEntrRsvTruthInfo, lawcAgntEntrRsvTruthInfo)

        Object.assign(assignedRegistration,
            {aplcNm:window.btoa(encodeURIComponent(registration.aplcNm)),
            pymnNm:window.btoa(encodeURIComponent(registration.pymnNm)),
            lawcAgntNm:window.btoa(encodeURIComponent(registration.lawcAgntNm)),
            aplcDerno:window.btoa(registration.aplcDerno),
            //pymnDerno:window.btoa(registration.pymnDerno),
            acctCardNo:window.btoa(registration.acctCardNo)
            //decLawcAgntCrypRrno:window.btoa(registration.decLawcAgntCrypRrno)
            })
        Object.assign(assignedEntrRsvTruthInfo,
            {drvLcnsNo:window.btoa(entrRsvTruthInfo.drvLcnsNo)})
            
        if(lawcAgntEntrRsvTruthInfo.drvLcnsNo !== null) {
            Object.assign(assignedLawcAgntEntrRsvTruthInfo,
                {drvLcnsNo:window.btoa(lawcAgntEntrRsvTruthInfo.drvLcnsNo)})
        }
    let reqData = {
        opmktRegistrationCapture: assignedRegistration,
        entrRsvTruthInfo: assignedEntrRsvTruthInfo,
        lawcAgntEntrRsvTruthInfo: assignedLawcAgntEntrRsvTruthInfo,
        openMarketAgrInfo: _.cloneDeep(openMarketAgrInfo),
        step: step
    }

    return  request({
        url: `/ococ/datacapture/openmarket/saveAppFormTemp`,
        method: 'post',
        data: reqData
    })
}

export function getRegistrationList(name, ssn1, ssn2) {
    let params = {
        accessType: 'E',
        custKdCd: 'B',
        requireType: 'R'
    }
    let header = {
        custNm: window.btoa(encodeURIComponent(name)), //success sample '7Iah7JiB7J20'
        custPersId: window.btoa(ssn1 + ssn2) //success sample 'NTkwODI1M
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getOpenmarketApplList`,
        method: 'get',
        headers: header,
        params
    })
}

export function getRegistration(applicationNumber, accessType) {
    let params = {
        accessType: accessType,
    }
    let headers = {
        crypAppfNo: applicationNumber
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getAppFormRead`,
        method: 'get',
        headers: headers,
        params
    })
}
export function getRegistrationInit(applicationNumber) {
    let headers = {
        crypAppfNo: applicationNumber
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getAppRead`,
        method: 'get',
        headers: headers
    })
}

export function getRegistrationForm(applicationNumber) {
    let headers = {
        crypAppfNo: applicationNumber
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getAppFormInfo`,
        method: 'get',
        headers: headers
    })
}
export function deleteRegistration(applicationNumber) {
    return  request({
        url: `/ococ/datacapture/v1/mobileregistrationcapture/deleteApplication/${applicationNumber}`,
        method: 'delete'
    })
}

export function getCcrdCnfm(creditInfo) {
    let params = {
        acntOwnerNi: creditInfo.acntOwnerNi,
        cardValdEndYymm: creditInfo.cardValdEndYymm,
        cdCmpCd: creditInfo.cdCmpCd
    }
    return  request({
        url: `/ococ/datacapture/auth/getCcrdCnfm`,
        method: 'get',
        headers: {
            'cardno': window.btoa(creditInfo.cardno)
        },
        params
    })
}

export function getPymInfoVaildation(pymInfo) {
    let params = {
        acntOwnrNo: pymInfo.acntOwnrNo,
        bankAcntNo: pymInfo.bankAcntNo,
        bankCd: pymInfo.bankCd,
        pymCustNm: pymInfo.pymCustNm,
        pymMthdCd: 'CM'
    }

    return  request({
        url: `/ococ/datacapture/auth/getPymInfoVaildation`,
        method: 'get',
        params
    })
}

export function getItemDstrDiscount(input) {
    let params = {
        applDscntTp : input.applDscntTp, //할인유형 코드
        applType : input.applType, //신청서 유형
        dealCd : input.dealCd, //대리점코드
        modelId : input.modelId, //선택된 모델 코드
        phonePayStyleCd : input.phonePayStyleCd, //선택된 요금제 코드
        addSuptAmtUseYn : input.addSuptAmtUseYn, //추가지원금 사용여부
        posCd : input.posCd, // POS코드 //[단통법폐지Prj] 단통법 폐지관련 필수 PARAM추가 됨. 2025.06.04 miyoung34
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getItemDstrDiscount`,
        method: 'get',
        params
    })
}

export function getItemDstrDiscountNew(input) {
    let params = {
        applDscntTp : input.applDscntTp, //할인유형 코드
        applType : input.applType, //신청서 유형
        dealCd : input.dealCd, //대리점코드
        modelId : input.modelId, //선택된 모델 코드
        phonePayStyleCd : input.phonePayStyleCd, //선택된 요금제 코드
        addSuptAmtUseYn : input.addSuptAmtUseYn, //추가지원금 사용여부
        onsaAplyPlnNm : input.onsaAplyPlnNm, //onsaAplyPlnNm
        posCd : input.posCd, // POS코드 //[단통법폐지Prj] 단통법 폐지관련 필수 PARAM추가 됨. 2025.06.04 miyoung34
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getItemDstrDiscountNew`,
        method: 'get',
        params
    })
}
// [단통법폐지Prj] Start 단통법 폐지관련 추가 됨. 2025.06.04 miyoung34
// 단말 지원금 + 유통망지원금 조회
export function getItemDstrDiscountNDbwnSuptAmt(input) {
    let params = {
        applDscntTp : input.applDscntTp, //할인유형 코드
        applType : input.applType, //신청서 유형
        trmMdlCd : input.trmMdlCd, //선택된 모델 코드
        prodCd : input.prodCd, //선택된 요금제 코드
        onsaAplyPlnNm : input.onsaAplyPlnNm, //onsaAplyPlnNm
        crypAppfNo: input.crypAppfNo,    // 신청서번호
        posCd : input.posCd
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getItemDstrDiscountNDbwnSuptAmt`,
        method: 'get',
        params
    })
}
// [단통법폐지Prj] End 단통법 폐지관련 추가 됨. 2025.06.04 miyoung34

export function getPricePlan(ppCd) {
    return  request({
        url: `/ococ/datacapture/openmarket/pricePlans/${ppCd}`,
        method: 'get'
    })
}

export function getItemDstrZero(input) {
    let params = {
        dealCd : input.dealCd, //대리점코드
        modelId : input.modelId, //선택된 모델 코드
    }
    return  request({
        url: `/ococ/datacapture/openmarket/getItemDstrZero`,
        method: 'get',
        params
    })
}